import React from 'react';
import { PROCUREMENT, SUPER_ADMIN } from '../../../../../utils/departments/helpers';
import { useUser } from '../../../../../hooks/shared/user/useUser';
import useCheckTwoDepartments from '../../../../../hooks/shared/custom/check-department/useCheckTwoDepartments';
import ProcurementNavBar from '../../../../layouts/procurement/ProcurementNavBar';
import AccountVehiclesBody from '../../accounts/vehicles/AccountVehiclesBody';

const ProcurementVehicles = ({ history }) => {
  useCheckTwoDepartments(`${PROCUREMENT}`, `${SUPER_ADMIN}`, history);
  const {
    profile: { firstName },
  } = useUser();

  return (
    <div className="s-layout">
      <main className="s-layout__content col-lg-10 p-0">
        <ProcurementNavBar currentPage="Vehicles" position={firstName} />
        <AccountVehiclesBody />
      </main>
    </div>
  );
};

export default ProcurementVehicles;
